export default __webpack_public_path__ + "static/media/MomentImg.7c99df96.jpg";